import React from 'react';
import { AreaChart, Area, ResponsiveContainer, YAxis } from 'recharts';
interface MiniSparklineProps {
  data: number[];
  isPositive: boolean;
  width?: number;
  height?: number;
}
export function MiniSparkline({
  data,
  isPositive,
  width = 100,
  height = 32
}: MiniSparklineProps) {
  const chartData = data.map((val, i) => ({
    i,
    val
  }));
  const color = isPositive ? '#00C87F' : '#E85D75';
  const minVal = Math.min(...data);
  const maxVal = Math.max(...data);
  const range = maxVal - minVal;
  const padding = range * 0.1;
  return <div style={{
    width,
    height
  }} data-id="element-1353">
      <ResponsiveContainer width="100%" height="100%" data-id="element-1354">
        <AreaChart data={chartData} margin={{
        left: 0,
        right: 0,
        top: 2,
        bottom: 2
      }} data-id="element-1355">
          <defs data-id="element-1356">
            <linearGradient id={`spark-${isPositive}-${data.length}`} x1="0" y1="0" x2="0" y2="1" data-id="element-1357">
              <stop offset="5%" stopColor={color} stopOpacity={0.2} data-id="element-1358" />
              <stop offset="95%" stopColor={color} stopOpacity={0} data-id="element-1359" />
            </linearGradient>
          </defs>
          <YAxis hide domain={[minVal - padding, maxVal + padding]} type="number" data-id="element-1360" />
          <Area type="monotone" dataKey="val" stroke={color} strokeWidth={1.5} fill={`url(#spark-${isPositive}-${data.length})`} isAnimationActive={false} data-id="element-1361" />
        </AreaChart>
      </ResponsiveContainer>
    </div>;
}